import { CheckboxOptions } from '@explorer/forms/base/FieldCheckbox';
import { getLanguageLabel } from '@explorer/helpers/getLanguageLabel/getLanguageLabel';

export const FORM_ID = 'TriggerCRAScan';

export const DEFAULT_LOCALE = 'en-US';

export const SUPPORTED_CRA_LOCALES = [
  'en-US',
  'en-GB',
  'en-AU',
  'en-DK',
  'en-SE',
  'en-CA',
  'de-DE',
  'fr-CA',
  'fr-FR',
] as const;

export const CRA_SUPPORTED_CURRENCIES = [
  'USD',
  'GBP',
  'EUR',
  'AUD',
  'SEK',
  'DKK',
  'CAD',
] as const;

const CRA_SUPPORTED_CURRENCY_SET = new Set<string>(CRA_SUPPORTED_CURRENCIES);

function isCraSupportedCurrency(
  value: string,
): value is (typeof CRA_SUPPORTED_CURRENCIES)[number] {
  return CRA_SUPPORTED_CURRENCY_SET.has(value);
}

export function parseCraCurrency(
  value: unknown,
): (typeof CRA_SUPPORTED_CURRENCIES)[number] | null {
  if (typeof value !== 'string' || !isCraSupportedCurrency(value)) {
    return null;
  }

  return value;
}

export const INITIAL_FORM_VALUES = {
  entity_name: '',
  entity_domain: '',
  domains: '',
  ip_addresses: '',
  industry: '',
  number_of_employees: 0,
  number_of_pii_records: 0,
  company_revenue: 0,
  locale: DEFAULT_LOCALE,
  currency: null,
  cobranded: null,
  scan_opts: {
    force: false,
  },
};

export const SCAN_OPTS: CheckboxOptions = [
  {
    label: {
      id: 'forms-presets.scan-opts-force',
    },
    name: 'force',
  },
];

export const LOCALE_OPTS: Options = SUPPORTED_CRA_LOCALES.map((locale) => ({
  label: getLanguageLabel({
    displayedLocale: locale,
    currentLocale: 'en-US',
    options: { includeCountry: true },
  }),
  value: locale,
}));

export const CURRENCY_OPTS: Options = CRA_SUPPORTED_CURRENCIES.map(
  (currency) => ({
    label: currency,
    value: currency,
  }),
);

export const COBRANDED_OPTS: Options = [
  {
    label: 'Acrisure',
    value: 'acrisure',
  },
  {
    label: 'CDW',
    value: 'cdw',
  },
];
